import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/core/alert.service';
import { ToastService } from 'src/app/core/toast.service';
import { ApiComandamesaService } from 'src/app/dao/api-comandamesa.service';
import { GlobalService } from 'src/app/dao/global.service';
import { Comandamesa } from 'src/app/model/comandamesa';

@Component({
  selector: 'app-gerenciarcomanda',
  templateUrl: './gerenciarcomanda.page.html',
  styleUrls: ['./gerenciarcomanda.page.scss'],
})
export class GerenciarcomandaPage implements OnInit {

  comandamesas: Comandamesa[] = [];
  comandamesa: Comandamesa;
  user: string;
  pass: string;
  tituloComandaMesa;


  aberto;
  emissao;
  producao;
  entrega;
  finalizado;
  cancelado;
  status_selecionado = "EM USO";
  status_string = "EM USO";
  loading = false;
  pularLinha = false;
  showTodas = false;
  rodarReload;


  constructor(private route: ActivatedRoute,
    private toast: ToastService,
    private alert: AlertService,
    private apicomandamesa: ApiComandamesaService,
    private global: GlobalService) { }



  ngOnInit() {
    this.user = this.global.user;
    this.pass = this.global.pass;
    this.tituloComandaMesa = this.global.comandaMesa;
    this.alterarFiltro(this.status_selecionado);
    
  }

  ionViewDidEnter(){
    this.rodarReload = true;
    this.reloadFunction();
  }

  ionViewDidLeave(){
    this.rodarReload = false;
  }

  ionViewWillEnter() {

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      this.pularLinha = true;
    }


    this.user = this.global.user;
    this.pass = this.global.pass;
    this.alterarFiltro(this.status_selecionado);
  }


  async loadComandaMesa() {
    this.apicomandamesa.listarTodas().then(res => {
      this.comandamesas = res;
      // this.toast.showSucess('Produtos obtidos com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter ' + this.global.comandaMesa + 's');
    });
  }

  delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

  async reloadFunction() {
    if(this.rodarReload){
    await this.delay(30000);
    this.loading = true;
    this.alterarFiltro(this.status_selecionado);
    console.log("Rodou reload");
    this.reloadFunction();
    }
  }


  reloadFunc(){
    this.loading = true;
    this.alterarFiltro(this.status_selecionado);
    console.log("Rodou reload Manual");
  }

  alterarFiltro(param) {
    this.loading = true;
    switch (param) {
      case 'LIBERADA': this.status_string = 'LIBERADAS';
      this.showTodas = false;
        break;

      case 'EM USO': this.status_string = 'EM USO';
      this.showTodas = false;
        break;

      case 'INATIVA': this.status_string = 'INATIVAS';
      this.showTodas = false;
        break;

      case 'TODAS': this.status_string = '';
      this.showTodas = true;
        break;

      // case 4: this.status_string = "TRAVADA";
      // break;
    }

    this.status_selecionado = param;

    if(this.status_selecionado === "EM USO"){
      this.status_selecionado = "EMUSO";
    }

    this.apicomandamesa.getByStatus(this.status_selecionado).then(res => {
      this.comandamesas = res;
      if (res.length < 0 || res.length === null) {
      }
      this.loading = false;
    }).catch(async err => {
      console.log('err', err);
      this.loading = false;
      // this.toast.showError('Erro ao obter Histórico');
    });
  }


}
